import { render } from "./BottomSheet.vue?vue&type=template&id=2b24c93a"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__